export enum ContactsVisibilityPermission {
    Hidden = 0,
    Visible = 1
}

export namespace ContactsVisibilityPermission {
    export function toString(contactsVisibilityPermission: ContactsVisibilityPermission): string {
        switch (contactsVisibilityPermission) {
            case ContactsVisibilityPermission.Hidden:
                return 'Hidden';
            case ContactsVisibilityPermission.Visible:
                return 'Visible';
            default:
                return null;
        }
    }

    export function listAll(): ContactsVisibilityPermission[] {
        return [ContactsVisibilityPermission.Hidden, ContactsVisibilityPermission.Visible];
    }

    export function parse(cvp: string): ContactsVisibilityPermission {
        return ContactsVisibilityPermission[cvp];
    }
}

export default ContactsVisibilityPermission;